export default () => ({
  reports: null,
  metrics: null,
  generalReport: null,
  recompraReport: null,
  filters: null,
});
